import React from 'react'
import './footer.css'
import logo from '../../assets/1739276909146.jpg'
import { Link, useLocation } from 'react-router-dom'

const Footer = () => {
    const location = useLocation();
    if(location.pathname.startsWith('/blog') || location.pathname.startsWith('/admin') || location.pathname.startsWith('/gallery') || location.pathname.startsWith('/tracking')){
        return null
    }
  return (
    <div className='footer_container'>
        <div className='footer_split'>
            <div className='footer_logo'>
                <img src={logo} alt="" />
                &copy; 2025 All rights reserved
            </div>
            <div className='developers'>
                <h1>Designed and Developed by:</h1>
                <p onClick={()=> window.open('https://gkalma.co.za', ('_blank'))}>Gkalma</p>
                <p onClick={()=> window.open('https://geegee.co.za', ('_blank'))}>GeeGee</p>
            </div>
            <div className='footer_links'>
                <Link to='/tracking' className='linktag'><li>Track your application</li></Link>
                <li>ewcdc games</li>
            </div>
           
        </div>
    </div>
  )
}

export default Footer